export default __webpack_public_path__ + "static/dagostino-3898c1fbf456ba27cc84399bb6a3205e.png";